import React from "react";
import { Button } from "./ui/button";
import { notePreviewFromContent } from "../lib/noteBlocks";

export function BLUNotePreview({ payload, busy, onFinalize, interactive = true }) {
  const heading = notePreviewFromContent(payload.content || "");

  return (
    <div
      className="rounded-[var(--t-event-pill-radius)] border border-[var(--t-border)] bg-[#FAFBFC] p-4"
      data-testid="blu-note-preview"
    >
      <div className="mb-1 text-[10px] font-normal uppercase tracking-[0.16em] text-[var(--t-meta)]">
        Portal note · Internal
      </div>
      <div className="font-heading text-sm tracking-tight text-[var(--t-text)]">
        {payload.title || `${payload.client_name} x TAĪSTU`}
      </div>
      {heading && heading !== "No body text yet." ? (
        <p className="mt-2 line-clamp-2 text-[12px] font-light leading-snug text-[var(--t-meta)]">{heading}</p>
      ) : null}
      {interactive ? (
        <Button
          type="button"
          className="mt-4 w-full !rounded-[var(--t-event-pill-radius)]"
          disabled={busy}
          onClick={onFinalize}
          data-testid="blu-note-save-btn"
        >
          {busy ? "Saving…" : "Save to Notes"}
        </Button>
      ) : null}
    </div>
  );
}
